import { animate, stagger, timeline } from 'motion';

const Navi = () => {
  const navEl = document.querySelector('.nav');
  const navItemEls = document.querySelectorAll('.nav-item');
  const secondaryNavEls = document.querySelectorAll('.secondary-nav');
  const siteLogoEl = document.querySelector('.site-logo');
  const marquee = navEl.querySelector('.nav-marquee');
  const transition = 100;

  if (!navEl) {
    return;
  }

  document.addEventListener('nav:toggle', (e) => {
    if (e.detail) {
      // open
      openNav();
    } else {
      // close
      closeNav();
    }
  });

  const openNav = () => {
    siteLogoEl.classList.add('nav-open');

    timeline([
      [navEl, { x: 0 }, { duration: 0.5, easing: [0.25, 0.1, 0.25, 1] }],

      [
        navItemEls,
        { y: 0, opacity: 1 },
        { duration: 0.5, delay: stagger(0.1), easing: [0.25, 0.1, 0.25, 1] },
      ],
      [
        siteLogoEl,
        { rotate: '360deg', filter: 'brightness(255)' },
        { duration: 0.5, easing: [0.25, 0.1, 0.25, 1], at: '-0.75' },
      ],
      [
        secondaryNavEls,
        { y: 0, opacity: 1 },
        {
          duration: 0.5,
          delay: stagger(0.1),
          easing: [0.25, 0.1, 0.25, 1],
          at: '-0.5',
        },
      ],
    ]);
  };

  const closeNav = (duration = 0.5) => {
    siteLogoEl.classList.remove('nav-open');

    timeline([
      [
        siteLogoEl,
        { filter: 'brightness(1)' },
        { duration: 0, easing: [0.25, 0.1, 0.25, 1], at: '<' },
      ],
      [
        navEl,
        { x: '100%' },
        { duration: duration, easing: [0.25, 0.1, 0.25, 1] },
      ],
      [
        siteLogoEl,
        { rotate: '-1080deg' },
        { duration: duration > 0 ?? 20, easing: [0, 1, 1, 1], at: '<' },
      ],
      [
        navItemEls,
        { opacity: 0, y: '30px' },
        {
          duration: duration,
          easing: [0.25, 0.1, 0.25, 1],
        },
      ],
      [
        secondaryNavEls,
        { opacity: 0, y: '30px' },
        {
          duration: duration,
          easing: [0.25, 0.1, 0.25, 1],
          at: '<',
        },
      ],
    ]).finished.then(() => {
      animate(siteLogoEl, { rotate: '0deg' }, { duration: 0 });
    });
  };

  closeNav(0);

  const insertMarquee = (text) => {
    const marq = document.createElement('div');
    marq.classList.add('flex', 'custom-marquee');
    marq.setAttribute('scrollamount', 60);

    const span = document.createElement('span');
    span.classList.add('inline-block');
    span.innerText = text;

    for (let i = 0; i < 20; i++) {
      marq.appendChild(span.cloneNode(true));
    }

    marq.addEventListener('animationend', (e) => {
      if (e.animationName === 'custom-marquee-in') {
        marquee.classList.remove('in');
        marquee.classList.add('loop');
      }
    });
    marquee.classList.add('in');

    marquee.appendChild(marq);
  };

  const replaceMarqueeText = (text) => {
    const marqueeChildren = marquee.querySelectorAll('span');

    marqueeChildren.forEach((el) => {
      el.style.transition = `opacity ${transition}ms`;
      el.style.opacity = 0;

      setTimeout((_) => {
        el.innerHTML = text;
        el.style.opacity = 1;
      }, transition);
    });
  };

  document.addEventListener('marquee:start', (e) => {
    const marqueeChildren = marquee.querySelectorAll('span');

    if (marqueeChildren && marqueeChildren.length) {
      // console.log('is hover');
      replaceMarqueeText(e.detail);
    } else {
      // console.log('is new hover');
      insertMarquee(e.detail);
    }
  });

  document.addEventListener('marquee:end', () => {
    marquee.style.transition = `opacity ${transition}ms`;
    marquee.style.opacity = 0;

    setTimeout((_) => {
      marquee.innerHTML = '';
      marquee.style.opacity = 1;
    }, transition);
  });
};

export default Navi;
